import React from 'react';

export const SideModalBody = ({
  bodyClass = '',
  children,
}: {
  bodyClass?: string;
  children: React.ReactNode;
}) => (
  <div id="side-modal-body" className={`my-16 px-8 sm:px-20 ${bodyClass}`}>
    {children}
  </div>
);

